import React from "react";
import { CollapsibleSectionTitle } from "./CollapsibleSectionTitle";

// Full-width title bar (spans label column + every month) for a collapsible
// row-group in CalendarView's .planner-grid - see PhaseTrackTitle.js's own
// comment for why title bars live in their own row, separate from whatever
// rows/labels sit under them in the narrow sticky label column (phase
// names, milestone names, stat labels - those stay put, only the title
// bar's width changed). PhaseTrackTitle.js wraps this for Training/Nutrition
// (it needs a per-track title key); Notes/Milestones/Tracked Results use
// this directly since their title is already a plain string.
export const PlannerTitleRow = ({
  title,
  badge,
  count,
  subtitle,
  isCollapsed,
  onToggleCollapse,
}) => (
  <div className="planner-title-row">
    <CollapsibleSectionTitle
      title={title}
      badge={badge}
      count={count}
      subtitle={subtitle}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    />
  </div>
);
